import { mapToBreakpoints } from '../../../mixins/mapToBreakpoints.js';

const getSidebarGapStyle = (steps, sidebarPosition) => ({
  theme
}) => {
  return mapToBreakpoints(steps, step => {
    return `padding-${sidebarPosition === 'left' ? 'right' : 'left'}:  ${theme.spacing[step]};`;
  });
};

export { getSidebarGapStyle };
//# sourceMappingURL=getSidebarGapStyle.js.map
